import React, { memo, useEffect, useState, useCallback } from 'react';
import Autocomplete from '../../../shared/components/Autocomplete';

const AutoCompleteDevices = ({
    getTypingDevicesRequest,
    getDevicesStatusesRequest,
    setStateDevices,
    devices: { fetching, devices, statuses, statuesFetching },
    deviceValue,
    handleDevice,
    placeholder,
    defaultOptions = null,
    label,
    gps: { gps_device },
    ...props
}) => {
    const [options, setOptions] = useState([{ ...defaultOptions }]);
    const [statusAssignedToGps, setStatusAssignedToGps] = useState(null);

    const handleSearchDevices = value => {
        const filters = {
            limit: 20,
            imei: value,
            'status!': statusAssignedToGps
        };

        if (value && typeof value === 'string' && value.length) {
            setStateDevices({ devices: [] });
            getTypingDevicesRequest(filters);
        }
    };

    const handleClearDevices = useCallback(() => {
        setStateDevices({ devices: [] });
        setOptions([{ ...defaultOptions }]);
    }, [setStateDevices, defaultOptions]);

    useEffect(() => {
        if(gps_device.device !== undefined){
        getDevicesStatusesRequest();
    }
    }, [getDevicesStatusesRequest]);

    useEffect(() => {
        if (devices.length) {
            setOptions([
                { ...defaultOptions },
                ...devices.map(device => ({
                    label: device.imei,
                    value: device._id
                }))
            ]);
        }
    }, [devices, defaultOptions]);

    useEffect(() => {
        if (statuses.length) {
            const statusAssignedToGps = statuses.find(st => st.code === 'asignado_a_gps');
            setStatusAssignedToGps(statusAssignedToGps._id);
        }
    }, [statuses]);

    return (
        <Autocomplete
            value={deviceValue}
            onChange={handleDevice}
            placeholder={placeholder}
            label={label}
            loading={fetching || statuesFetching}
            options={options}
            onInputChangeAction={handleSearchDevices}
            isDisabled={false}
            resetAction={handleClearDevices}
            {...props}
        />
    );
};

export default memo(AutoCompleteDevices);
